export const TILE_TITLE = 'Continue watching';
export const TILE_SUBTITLE = 'Playlist subtitle(optional)';
export const PARTNER_ID = '2563011';
export const SECRET_KEY = '1ecae30b83a4d215de80f5a53b844d1c';
export const PRIVILEGES = 'disableentitlement';

export const USER_KEY_API =
  'https://www.kaltura.com/api_v3/service/session/action/start';
export const VIDEO_DATA_API =
  'https://www.kaltura.com/api_v3/service/baseentry/action/get';

export const FORMAT = 'Format:';
export const VIEWS = 'views';

export const TEST_TITLE = 'Test Video';
export const TEST_ENTRY_ID = '12345';
export const TEST_USER_KEY_KS = 'userKey';
export const ARROW_DOWN = 'ArrowDown';
export const ARROW_UP = 'ArrowUp';
